import { ArrowRight, MapPin, Sparkles } from "lucide-react";

const HERO_IMG =
    "https://images.pexels.com/photos/31298995/pexels-photo-31298995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function Hero() {
    const scrollTo = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[92vh] flex items-center overflow-hidden"
        >
            {/* background image */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${HERO_IMG})` }}
                aria-hidden="true"
            />
            {/* overlays */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/30 to-transparent" />
            <div
                className="absolute inset-0 noise-overlay opacity-[0.35] mix-blend-overlay"
                aria-hidden="true"
            />
            {/* radial purple glow */}
            <div
                className="absolute -left-40 top-1/3 w-[520px] h-[520px] rounded-full blur-[120px] opacity-60"
                style={{
                    background:
                        "radial-gradient(circle, rgba(157,76,221,0.55), transparent 60%)",
                }}
            />

            <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full py-32">
                <div className="max-w-3xl">
                    <div className="ac-fade-up inline-flex items-center gap-2 text-[#9D4CDD] font-heading text-xs uppercase tracking-[0.32em] font-bold mb-6">
                        <Sparkles size={14} />
                        <span>Premium Mobile Detailing</span>
                    </div>

                    <h1
                        data-testid="hero-headline"
                        className="ac-fade-up ac-delay-1 font-heading text-5xl md:text-7xl font-black uppercase tracking-tighter text-white leading-[0.95]"
                    >
                        Showroom Shine,{" "}
                        <span className="text-[#9D4CDD]">Delivered.</span>
                    </h1>

                    <p className="ac-fade-up ac-delay-2 mt-6 text-base md:text-lg text-white/70 leading-relaxed max-w-xl">
                        Surprise, Arizona&apos;s meticulous auto detail crew. Hand-washed
                        exteriors, deep-cleaned interiors, and full restorations —
                        done right on your driveway.
                    </p>

                    <div className="ac-fade-up ac-delay-3 mt-10 flex flex-wrap gap-4">
                        <button
                            data-testid="hero-view-services-btn"
                            onClick={() => scrollTo("services")}
                            className="group inline-flex items-center gap-3 bg-[#9D4CDD] text-white px-8 py-4 font-heading text-[12px] font-bold tracking-[0.24em] uppercase hover:bg-[#B366F9] transition-all hover:shadow-[0_0_24px_rgba(157,76,221,0.45)]"
                        >
                            View Packages
                            <ArrowRight
                                size={16}
                                className="transition-transform group-hover:translate-x-1"
                            />
                        </button>
                        <button
                            data-testid="hero-book-now-btn"
                            onClick={() => scrollTo("contact")}
                            className="inline-flex items-center gap-3 bg-transparent text-white border border-white/25 px-8 py-4 font-heading text-[12px] font-bold tracking-[0.24em] uppercase hover:border-white hover:bg-white/5 transition-all"
                        >
                            Book a Detail
                        </button>
                    </div>

                    <div className="ac-fade-up ac-delay-4 mt-14 flex flex-wrap items-center gap-8 text-xs text-white/50 font-sans tracking-wide">
                        <div className="flex items-center gap-2">
                            <MapPin size={14} className="text-[#9D4CDD]" />
                            <span>Serving Surprise, AZ &amp; West Valley</span>
                        </div>
                        <div className="flex items-center gap-6">
                            <div>
                                <div className="font-heading font-black text-white text-2xl">
                                    500+
                                </div>
                                <div className="uppercase tracking-[0.18em]">
                                    Vehicles Detailed
                                </div>
                            </div>
                            <div className="h-8 w-px bg-white/10" />
                            <div>
                                <div className="font-heading font-black text-white text-2xl">
                                    4.9★
                                </div>
                                <div className="uppercase tracking-[0.18em]">
                                    Client Rating
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
